import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { IoIosWarning } from 'react-icons/io';
import formatDuration from '../../../../../../../helpers/formatters/formatDuration';

const LayoverInfo = ({ stop, index, flights, tooltipClasses }) => {
  if (!(index > 0 && stop.layoverDuration > 0)) {
    return null;
  }

  const prevFlight = flights[index - 1];

  const shouldShowTransferWarning = prevFlight.destinationAirportCode !== stop.originAirportCode;

  const shouldShowTerminalChangeWarning =
    prevFlight.destinationAirportCode === stop.originAirportCode &&
    prevFlight.destinationAirportTerminalId &&
    stop.originAirportTerminalId &&
    prevFlight.destinationAirportTerminalId !== stop.originAirportTerminalId;

  return (
    <div className="block">
      {formatDuration(stop.layoverDuration)} in{' '}
      <Tooltip
        arrow
        classes={tooltipClasses}
        title={`${stop.originAirportFullName || stop.originAirportCode}`}
        placement="top"
        enterTouchDelay={0}
      >
        <span> {stop.originAirportCode}</span>
      </Tooltip>
      {shouldShowTransferWarning && (
        <Tooltip
          arrow
          classes={tooltipClasses}
          title={`Transfer from ${prevFlight.destinationAirportCode} to ${stop.originAirportCode}`}
          placement="top"
          enterTouchDelay={0}
        >
          <span>
            <IoIosWarning className="inline-block text-lg text-red-500 -mt-1" />
          </span>
        </Tooltip>
      )}
      {shouldShowTerminalChangeWarning && (
        <Tooltip
          arrow
          classes={tooltipClasses}
          title={`Transfer from Terminal ${prevFlight.destinationAirportTerminalId} to Terminal ${stop.originAirportTerminalId} at ${stop.originAirportCode}`}
          placement="top"
          enterTouchDelay={0}
        >
          <span className="inline-block text-red-500">
            <IoIosWarning className="inline-block text-lg -mt-1 ml-1" />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

LayoverInfo.propTypes = {
  stop: PropTypes.shape({
    originAirportCode: PropTypes.string.isRequired,
    originAirportFullName: PropTypes.string,
    originAirportTerminalId: PropTypes.string,
    layoverDuration: PropTypes.number.isRequired,
    departureDateTime: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      destinationAirportCode: PropTypes.string.isRequired,
      destinationAirportTerminalId: PropTypes.string,
      originAirportCode: PropTypes.string.isRequired,
      originAirportTerminalId: PropTypes.string,
      layoverDuration: PropTypes.number,
      departureDateTime: PropTypes.string.isRequired,
    }),
  ).isRequired,
  tooltipClasses: PropTypes.shape({}).isRequired,
};

export default LayoverInfo;
